import { Theme } from "@mui/material";

import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    search: {
      position: "relative",
      borderRadius: theme.shape.borderRadius,
      marginLeft: 0,
      width: "310px",
      height: "40px",
      background: "#F4F6F8",
      [theme.breakpoints.down('lg')]: {
        width: "270px",
      },

      [theme.breakpoints.down('sm')]: {
        width: "180px",
      },
      "&:focus-within": {
        boxShadow: "inset 0 0 0 2px #00338D, 0 0 4px 3px #F4F6F8",
        outline: "10px #00338D",
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "inline",
      alignItems: "center",
      justifyContent: "center",
      color: "#000000",
    },
    inputRoot: {
      color: "#000000",
    },

    inputInput: {
      padding: theme.spacing(1.3, 0, 1, 0),
      transition: theme.transitions.create("width"),
      [theme.breakpoints.down("xl")]: {
        width: "260px",
      },
      [theme.breakpoints.down('lg')]: {
        width: "200px",
      },
      [theme.breakpoints.down('md')]: {
        width: "180px",
      },
      [theme.breakpoints.down('sm')]: {
        width: "130px",
      },
      "&::placeholder ": {
        color: "#fffff",
        opacity: 1,
        [theme.breakpoints.down('sm')]: {
          fontSize: "14px",
          lineHeight: "14px",
        },
      },
    },
    searchIconButton: {
      padding: "10px 5px 10px 7px",
    },
    alertIcon: {
      fontSize: "13px",
    },
  })
);
